<div
  class="bl-display--block bl-display-lg--flex bl-justify-content--center bl-margin-x--auto bl-overflow-wrap--break-word bl-font-color--black bl-text-align--center">
  <ng-container *ngTemplateOutlet="blockTemplate,
    context: {
      'showBlock': phoneBlockHasData,
      'iconSrcName': 'phone-icon',
      'title': ('contactBlock/callHeading' | dictionary),
      'content': phoneBlockContent,
      'automationId': 'generic-error-card-phone-contact'}",>
  </ng-container>

  <ng-container *ngTemplateOutlet="blockTemplate,
  context: {
    'showBlock': emailBlockHasData,
    'iconSrcName': 'email-icon',
    'title': ('contactBlock/emailHeading' | dictionary),
    'content': emailBlockContent,
    'automationId': 'generic-error-card-email-contact'}">
  </ng-container>

  <ng-container *ngTemplateOutlet="blockTemplate,
  context: {
    'showBlock': addressBlockHasData,
    'iconSrcName': 'branch-icon',
    'title': ('contactBlock/branchHeading' | dictionary),
    'content': addressBlockContent,
    'automationId': 'generic-error-card-address-contact'}">
  </ng-container>
</div>


<!-- Base block template -->
<ng-template #blockTemplate let-showBlock="showBlock" let-iconSrcName="iconSrcName" let-title="title" let-automationId="automationId"
  let-contentTemplate="content">
  <div *ngIf="showBlock"
    class="contact-block bl-display--block bl-display-sm--flex bl-display-lg--block bl-border bl-border-radius--16 bl-padding--24 bl-margin-bottom--24"
    [attr.data-automation-id]="automationId">
    <header>
      <img [src]="'assets/images/'+iconSrcName+'.svg'" class="contact-icon bl-margin-bottom--16" [alt]="iconSrcName">
      <span class="bl-text-style--display-6 bl-display--block">
        {{title}}
      </span>
    </header>
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  </div>
</ng-template>

<!-- Phone block template -->
<ng-template #phoneBlockContent>
  <section class="bl-flex--auto">
    <p *ngFor="let phone of contactInfoByType(lenderData.contacts, 'phone')" class="bl-margin-bottom--8">
      <span *ngIf="phone.description" class="bl-display--block bl-font-size--14">
        {{phone.description}}
      </span>
      <a href="tel:{{phone.value}}" target="_blank" class="bl-display--block" rel="noopener">
        {{phone.value | mask: '(000) 000-0000'}} {{phone.additionalValue}}
      </a>
    </p>
    <!-- <span *ngIf="lenderData?.availableHours && lenderData?.availableHours.length > 0"
      class="bl-text-style--secondary-text-2 bl-display--block bl-margin-top--24">
      {{"contactBlock/available" | dictionary}}
      <ng-container *ngFor="let item of lenderData.availableHours">
        <p class="bl-text-style--tertiary-text-2 bl-margin-bottom--0">{{ item?.days[0] === 'WorkWeek' ? 'Monday - Friday'
          : item.days }}</p>
        <p class="bl-text-style--tertiary-text-1 bl-margin-bottom--0">{{ item?.openTime }} - {{ item?.closeTime }}
          {{lenderData?.timezone}}</p>
      </ng-container>
    </span> -->
  </section>
</ng-template>

<!-- Email block template -->
<ng-template #emailBlockContent>
  <section class="bl-flex--auto">
    <span class="bl-display--block bl-text-style--secondary-text-1">{{"contactBlock/emailDescription" |
      dictionary}}</span>
    <p *ngFor="let email of contactInfoByType(lenderData?.contacts, 'email')" class="bl-margin-bottom--8">
      <span *ngIf="email?.description" class="bl-display--block bl-font-size--14">
        {{email.description}}
      </span>
      <a href="mailto:{{email.value}}" target="_blank" class="bl-display--block" rel="noopener">
        {{email.value}} {{email.additionalValue}}
      </a>
    </p>
  </section>
</ng-template>

<!-- Address block template -->
<ng-template #addressBlockContent>
  <section class="bl-flex--auto">
    <p *ngIf="lenderData?.lenderName" class="bl-font-weight--700 bl-margin-bottom--0">
      {{lenderData.lenderName}}
    </p>
    <address>
      <span class="bl-display--block">{{lenderData.address1}}</span>
      <span class="bl-display--block">{{lenderData.address2}}</span>
      <span class="bl-display--block">
        {{lenderData.city ? lenderData.city + ', ' : ''}}
        {{lenderData.state}} {{lenderData.zipCode}}
      </span>
    </address>
  </section>
</ng-template>
